/**
 * Бренд установки. API впрыскивает window.__BRANDING__ в index.html
 * (apps/api/src/routes/static.ts); в vite-dev его нет — работают дефолты,
 * совпадающие с историческими строками.
 */
export interface Branding {
  name: string;
  tabTitle: string;
  siteUrl: string;
  supportUrl: string;
  /** Реферальная ссылка AllPay (ALLPAY_REF_URL): задана — в подвале оплаты строка про Allpay вместо «Powered by». */
  allpayRefUrl: string;
  /** Поле «Мессенджер для связи» на чекауте; по умолчанию включено. */
  messengerField: boolean;
  /** Поле «Ссылка после оплаты» у продукта (POST_PURCHASE_LINK=on); по умолчанию выключено. */
  postPurchaseLink: boolean;
  /** Кнопка «Войти через Google» на /login; включается переменными GOOGLE_*. */
  googleLogin: boolean;
  /** Вход по паролю в админку; false — установка «только Google» (ADMIN_PASSWORD_LOGIN=off). */
  passwordLogin: boolean;
}

const injected =
  typeof window !== 'undefined'
    ? ((window as unknown as { __BRANDING__?: Partial<Branding> }).__BRANDING__ ?? null)
    : null;

export const BRAND: Branding = {
  name: injected?.name || 'Digital Bandito',
  tabTitle: injected?.tabTitle || 'Digital Bands Payments',
  siteUrl: injected?.siteUrl || '',
  supportUrl: injected?.supportUrl || 'https://t.me/katzandkatzbot',
  allpayRefUrl: injected?.allpayRefUrl || '',
  messengerField: injected?.messengerField !== false,
  postPurchaseLink: injected?.postPurchaseLink === true,
  googleLogin: injected?.googleLogin === true,
  passwordLogin: injected?.passwordLogin !== false,
};
